export default {
	all_yout_user_data_will_be_deleted_and_this_process_isnt_reversible:
		'ALL YOUR DATA WILL BE DELETED, THIS IS IRREVERSIBLE!',
	check_in_on_a_event: 'checked in for an event',
	commented_the_news: 'commented on the news',
	earned_a_certification_on_the_trail: 'earned a certification on the trail',
	earned_a_certification_on_the_training: 'earned a certification on the training',
	earned_the_badge: 'earned a badge',
	evaluated_the_podcast: 'evaluated the podcast',
	evaluated_the_trail: 'evaluated the trail',
	evaluated_the_training: 'evaluated the training',
	extra_activity: 'extra activity',
	favorited_the_podcast: 'favourited the podcast',
	favorited_the_trail: 'favourited the trail',
	favorited_the_training: 'favourited the training',
	i_do_confirm_the_deletion_of_my_user_data: 'CONFIRM ACCOUNT CLOSURE',
	liked_the_podcast: 'liked the podcast',
	liked_the_trail: 'liked the trail',
	liked_the_training: 'liked the training',
	liked_the_live_class: 'liked the live class',
	evaluated_the_live_class: 'evaluated the live class',
	liked_the_presential_event: 'liked the presential event',
	evaluated_the_presential_event: 'evaluated the presential event',
	new_sale_informed: 'new sale informed',
	points_were_awarded_for: 'Points were awarded for',
	the_file: 'File',
	the_product: 'Product',
	the_trail: 'The trail',
	the_training: 'The training',
	the_webinar: 'Webinar',
	there_are_no_activities_at_the_moment: 'There are no activities at the moment',
	to_confirm_enter_your_name: 'To continue, enter your name:',
	close_account: 'Close account',
	training_finished_on_irep: 'training finished in Intel® Retail Edge Program',
	upgrading_to_level: 'upgrading to level',
	was_published_f: 'was published ',
	was_published_on_the_library: 'was published in the library',
	was_published: 'was published',
	was_purchased: 'was purchased',
}
